import { BlockVisibilitySettingsStateInterface } from './types';

export const initialBlockVisibilitySettingsState: BlockVisibilitySettingsStateInterface = { blockVisibility: {} };
